"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mine = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var systemTab_1 = require("../../model/systemTab");
var service_1 = require("../../../library/base/service");
var Mine = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Mine, _super);
    function Mine() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '我的标签';
        _this.code = '100004';
        _this.desc = "";
        _this.requestParams = new systemTab_1.MineRequest();
        // public responseParams: LoginResponse;
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Mine;
}(service_1.BaseService));
exports.Mine = Mine;
//# sourceMappingURL=mine.js.map